const STATUS_ICONS = {
  draft: "fa-pencil",
  awaiting_configuration: "fa-pencil",
  scheduled: "fa-calendar-days",
  live: "fa-check",
  completed: "fa-check",
  cancel_hold: "fa-circle",
  canceled: "fa-circle",
  pending_approval: "fa-regular fa-clock",
  pending_compliance_approval: "fa-regular fa-clock",
  pending_network_audit: "fa-regular fa-clock",
  pending_network_start: "fa-regular fa-clock",
  pending_submission: "fa-regular fa-clock",
  pending_creative_submission: "fa-regular fa-clock",
  pending_extend: "fa-regular fa-clock",
  pending_recurrence: "fa-regular fa-clock",
  create_failed: "fa-circle-exclamation",
  payment_failed: "fa-circle-exclamation",
  compliance_rejected: "fa-circle-exclamation",
  network_rejected: "fa-circle-exclamation",
  submission_failed: "fa-circle-exclamation"
};

const getCampaignStatusIcon = (status, statusCategory) => {
  if (statusCategory === "action-required") return "fa-circle-exclamation";
  if (STATUS_ICONS[status]) return STATUS_ICONS[status];
  return "fa-circle";
};

export { STATUS_ICONS };

export default getCampaignStatusIcon;
